import { render, staticRenderFns } from "./TrademarkContent.vue?vue&type=template&id=f0fb67d0&scoped=true"
import script from "./TrademarkContent.vue?vue&type=script&lang=js"
export * from "./TrademarkContent.vue?vue&type=script&lang=js"
import style0 from "./TrademarkContent.vue?vue&type=style&index=0&id=f0fb67d0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fb67d0",
  null
  
)

export default component.exports